import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { IconPlus, IconTrash03 } from "@pentabd/icons";
import { Button, SectionHeader } from "@pentabd/ui";

import { InputTextAreaRow, InputTextRow } from "@components";

import { AGREEMENT_FIELDS } from "../..";
import { getAccess } from "@helpers/permissionController";
import { useUser } from "@hooks/useUser";

export const VendorWithnessInfo = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation();

  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  const {
    fields: vendorWithnessInfoFields,
    append: vendorWithnessInfoAppend,
    remove: vendorWithnessInfoRemove,
  } = useFieldArray({
    control,
    name: "vendorWitness",
  });

  return (
    <>
      <SectionHeader
        title={t("PROCUREMENT_CREATE.AGREEMENT.FORM.VENDOR_WITNESS.TITLE")}
      />

      {vendorWithnessInfoFields.map((item: any, index) => {
        return (
          <>
            <InputTextRow
              label="PROCUREMENT_CREATE.AGREEMENT.FORM.VENDOR_WITNESS.NAME"
              register={{
                ...register(
                  `vendorWitness.${index}.${AGREEMENT_FIELDS.VENDOR_WITNESS.NAME}`,
                ),
              }}
            />

            <InputTextRow
              label="PROCUREMENT_CREATE.AGREEMENT.FORM.VENDOR_WITNESS.EMAIL"
              register={{
                ...register(
                  `vendorWitness.${index}.${AGREEMENT_FIELDS.VENDOR_WITNESS.EMAIL}`,
                ),
              }}
              error={errors as any}
            />

            <InputTextRow
              label="PROCUREMENT_CREATE.AGREEMENT.FORM.VENDOR_WITNESS.DESIGNATION"
              register={{
                ...register(
                  `vendorWitness.${index}.${AGREEMENT_FIELDS.VENDOR_WITNESS.DESIGNATION}`,
                ),
              }}
            />

            <InputTextRow
              label="PROCUREMENT_CREATE.AGREEMENT.FORM.VENDOR_WITNESS.PHONE_NUMBER"
              register={{
                ...register(
                  `vendorWitness.${index}.${AGREEMENT_FIELDS.VENDOR_WITNESS.PHONE_NUMBER}`,
                ),
              }}
            />

            <InputTextAreaRow
              label="PROCUREMENT_CREATE.AGREEMENT.FORM.VENDOR_WITNESS.DETAILS"
              register={{
                ...register(
                  `vendorWitness.${index}.${AGREEMENT_FIELDS.VENDOR_WITNESS.DETAILS}`,
                ),
              }}
            />

            <div className="row">
              <div className="col-lg-3"></div>
              <div className="col-lg-7 text-end">
                {getAccess(roles, "PROCUREMENT_HR") && (
                  <Button
                    htmlType="button"
                    type="danger"
                    fill="outline"
                    size="sm"
                    onClick={() => vendorWithnessInfoRemove(index)}
                  >
                    <IconTrash03 size="20" fill="danger" />
                    {t("PROCUREMENT_CREATE.AGREEMENT.FORM.DELETE_BUTTON_TEXT")}
                  </Button>
                )}
              </div>
            </div>
          </>
        );
      })}
      <div className="col-lg-12">
        {getAccess(roles, "PROCUREMENT_HR") && (
          <Button
            htmlType="button"
            type="light"
            fill="outline"
            onClick={() => vendorWithnessInfoAppend({})}
            size="sm"
          >
            <IconPlus size="20" fill="dark" />
            {t("PROCUREMENT_CREATE.AGREEMENT.FORM.ADD_MORE_BUTTON_TEXT")}
          </Button>
        )}
      </div>
    </>
  );
};
